import { Typography } from "../typography";
import { useHelpText, UseHelpTextProps } from "./use-help-text";

export type HelpTextProps = UseHelpTextProps;

export const HelpText = (props: HelpTextProps) => {
  const { className, children, styles, componentProps } = useHelpText(props);

  return (
    <Typography
      as="span"
      className={styles.base({ className })}
      fontSize="body-sm"
      {...componentProps}
    >
      {children}
    </Typography>
  );
};
